module.exports = __webpack_public_path__ + "img/tufa15.20865ea8.jpg";